var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
      label: 0,
      sent: function () {
        if (t[0] & 1) throw t[1];
        return t[1];
      },
      trys: [],
      ops: []
    },
    f,
    y,
    t,
    g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;
  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }
  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");
    while (g && (g = 0, op[0] && (_ = 0)), _) try {
      if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
      if (y = 0, t) op = [op[0] & 2, t.value];
      switch (op[0]) {
        case 0:
        case 1:
          t = op;
          break;
        case 4:
          _.label++;
          return {
            value: op[1],
            done: false
          };
        case 5:
          _.label++;
          y = op[1];
          op = [0];
          continue;
        case 7:
          op = _.ops.pop();
          _.trys.pop();
          continue;
        default:
          if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
            _ = 0;
            continue;
          }
          if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
            _.label = op[1];
            break;
          }
          if (op[0] === 6 && _.label < t[1]) {
            _.label = t[1];
            t = op;
            break;
          }
          if (t && _.label < t[2]) {
            _.label = t[2];
            _.ops.push(op);
            break;
          }
          if (t[2]) _.ops.pop();
          _.trys.pop();
          continue;
      }
      op = body.call(thisArg, _);
    } catch (e) {
      op = [6, e];
      y = 0;
    } finally {
      f = t = 0;
    }
    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};
import React from 'react';
import styled, { css } from 'styled-components';
import { breakpoints, theme } from '@shapeable/theme';
import { EntityLink } from './entity-link';
import { ContentNode } from './content-node';
import { IconButton } from '../elements/icon-button';
import { useLang } from '../hooks/use-lang';
import { BinIconGlyph, PencilUnderlineIconGlyph, ReplyIconGlyph, ThumbsUpFilledIconGlyph, ThumbsUpIconGlyph } from '@shapeable/icons';
import { EntityBubbleImage } from './entity-bubble-image';
import { EntityStack } from './entity-stack';
import { useActivePerson } from '../hooks/use-active-person';
import { useCommentMutations } from '../hooks/use-comment-mutations';
import { EntityProvider } from '../context/entity-context';
import { formatDateTimeString } from '@shapeable/utils';
import { EllipsisButton } from '../elements/ellipsis-button';
import { InfoTooltip } from '../elements/info-tooltip';
export var CommentDefaultProps = {
  isReply: false,
  showEditControls: true
};
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    display: flex;\n    font-size: ", ";\n    padding: ", ";\n\n    ", "\n\n    .shp--image-asset-embed {\n      margin: ", " 0;\n    }\n    \n  "], ["\n    display: flex;\n    font-size: ", ";\n    padding: ", ";\n\n    ", "\n\n    .shp--image-asset-embed {\n      margin: ", " 0;\n    }\n    \n  "])), theme.FONT_SIZE(14), theme.UNIT(3), function (_a) {
    var _isReply = _a._isReply;
    return false && css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      border-left: 4px solid ", ";\n    "], ["\n      border-left: 4px solid ", ";\n    "])), theme.COLOR('line-very-subtle'));
  }, theme.UNIT(2)),
  tablet: css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  "], ["\n  "]))),
  desktop: css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    font-size: ", ";\n  "], ["\n    font-size: ", ";\n  "])), theme.FONT_SIZE(15))
});
var AvatarStyles = breakpoints({
  base: css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    margin-right: ", ";\n    flex-shrink: 0;\n    display: flex;\n    flex-direction: column;\n    align-self: flex-start;\n  "], ["\n    margin-right: ", ";\n    flex-shrink: 0;\n    display: flex;\n    flex-direction: column;\n    align-self: flex-start;\n  "])), theme.UNIT(3))
});
var BodyStyles = breakpoints({
  base: css(templateObject_6 || (templateObject_6 = __makeTemplateObject([" \n    flex-grow: 1;\n    margin: 0;\n  "], [" \n    flex-grow: 1;\n    margin: 0;\n  "])))
});
var CreatorStyles = breakpoints({
  base: css(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n    color: ", ";\n    font-weight: 600;\n    font-size: 1em;\n  "], ["\n    color: ", ";\n    font-weight: 600;\n    font-size: 1em;\n  "])), theme.COLOR('strong'))
});
var SourceItemStyles = breakpoints({
  base: css(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n    white-space: nowrap;\n    margin-left: ", ";\n  "], ["\n    white-space: nowrap;\n    margin-left: ", ";\n  "])), theme.UNIT(1)),
  tablet: css(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n    margin-left: ", ";\n\n    &:before {\n      content: '\u2022';\n      color: ", ";\n      margin-right: ", ";\n    }\n  "], ["\n    margin-left: ", ";\n\n    &:before {\n      content: '\u2022';\n      color: ", ";\n      margin-right: ", ";\n    }\n  "])), theme.UNIT(2), theme.COLOR('text-subtle'), theme.UNIT(2))
});
var WhenStyles = breakpoints({
  base: css(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n    color: ", ";\n    text-transform: uppercase;\n  "], ["\n    color: ", ";\n    text-transform: uppercase;\n  "])), theme.COLOR('text-subtle'))
});
var OrganisationStyles = breakpoints({
  base: css(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n    color: ", ";\n    display: none;\n    font-size: 1em;\n    ", ";\n  "], ["\n    color: ", ";\n    display: none;\n    font-size: 1em;\n    ", ";\n  "])), theme.COLOR("text-subtle"), SourceItemStyles),
  tablet: css(templateObject_12 || (templateObject_12 = __makeTemplateObject(["\n    display: inline-block;\n  "], ["\n    display: inline-block;\n  "])))
});
var HeaderSourcesStyles = breakpoints({
  base: css(templateObject_13 || (templateObject_13 = __makeTemplateObject(["\n    margin: 0 0 ", " 0;\n    display: flex;\n    flex-wrap: wrap;\n    font-size: 1em;\n    justify-content: space-between;\n  "], ["\n    margin: 0 0 ", " 0;\n    display: flex;\n    flex-wrap: wrap;\n    font-size: 1em;\n    justify-content: space-between;\n  "])), theme.UNIT(2)),
  tablet: css(templateObject_14 || (templateObject_14 = __makeTemplateObject(["\n    margin: 0 0 ", " 0;\n  "], ["\n    margin: 0 0 ", " 0;\n  "])), theme.UNIT(1.5))
});
var UserControlsStyles = breakpoints({
  base: css(templateObject_15 || (templateObject_15 = __makeTemplateObject(["\n    display: flex;\n    align-items: center;\n    padding-right: ", ";\n  "], ["\n    display: flex;\n    align-items: center;\n    padding-right: ", ";\n  "])), theme.UNIT(4)),
  tablet: css(templateObject_16 || (templateObject_16 = __makeTemplateObject(["\n    padding-right: 0;\n  "], ["\n    padding-right: 0;\n  "])))
});
var TimeDatesStyles = breakpoints({
  base: css(templateObject_17 || (templateObject_17 = __makeTemplateObject(["\n    display: flex;\n    align-items: center;\n    gap: ", ";\n  "], ["\n    display: flex;\n    align-items: center;\n    gap: ", ";\n  "])), theme.UNIT(3))
});
var CommentStyles = breakpoints({
  base: css(templateObject_18 || (templateObject_18 = __makeTemplateObject(["\n    line-height: 1.5em;\n    font-weight: 400;\n\n    img {\n      margin-top: ", ";\n      width: 100%;\n      max-width: 500px !important; \n      height: auto;\n    }\n\n    .shp--entity-content-embed {\n      margin-top: ", ";\n    }\n\n    p {\n      margin-top: 0; \n    }\n  "], ["\n    line-height: 1.5em;\n    font-weight: 400;\n\n    img {\n      margin-top: ", ";\n      width: 100%;\n      max-width: 500px !important; \n      height: auto;\n    }\n\n    .shp--entity-content-embed {\n      margin-top: ", ";\n    }\n\n    p {\n      margin-top: 0; \n    }\n  "])), theme.UNIT(2), theme.UNIT(2))
});
var ButtonStyles = breakpoints({
  base: css(templateObject_19 || (templateObject_19 = __makeTemplateObject(["\n    text-transform: none;\n    font-size: 1em;\n     &:before {\n      content: '\u2022';\n      color: ", ";\n      margin-right: ", ";\n    }\n  "], ["\n    text-transform: none;\n    font-size: 1em;\n     &:before {\n      content: '\u2022';\n      color: ", ";\n      margin-right: ", ";\n    }\n  "])), theme.COLOR('text-subtle'), theme.UNIT(1)),
  tablet: css(templateObject_20 || (templateObject_20 = __makeTemplateObject(["\n    &:before {\n      margin-right: ", ";\n    }\n  "], ["\n    &:before {\n      margin-right: ", ";\n    }\n  "])), theme.UNIT(2))
});
var EditButtonStyles = breakpoints({
  base: css(templateObject_21 || (templateObject_21 = __makeTemplateObject(["\n    ", ";\n    ", ";\n  "], ["\n    ", ";\n    ", ";\n  "])), SourceItemStyles, ButtonStyles)
});
var DeleteButtonStyles = breakpoints({
  base: css(templateObject_22 || (templateObject_22 = __makeTemplateObject(["\n    ", ";\n    ", ";\n    \n  "], ["\n    ", ";\n    ", ";\n    \n  "])), SourceItemStyles, ButtonStyles)
});
var FooterSourcesStyles = breakpoints({
  base: css(templateObject_23 || (templateObject_23 = __makeTemplateObject(["\n    margin: ", " 0 ", " 0;\n    display: flex;\n    flex-wrap: wrap;\n    font-size: 1em;\n    padding-top: ", ";\n    border-top: 1px solid ", ";\n  "], ["\n    margin: ", " 0 ", " 0;\n    display: flex;\n    flex-wrap: wrap;\n    font-size: 1em;\n    padding-top: ", ";\n    border-top: 1px solid ", ";\n  "])), theme.UNIT(4), theme.UNIT(1), theme.UNIT(4), theme.COLOR('line-very-subtle')),
  tablet: css(templateObject_24 || (templateObject_24 = __makeTemplateObject(["\n    margin: ", " 0 ", " 0;\n  "], ["\n    margin: ", " 0 ", " 0;\n  "])), theme.UNIT(4), theme.UNIT(1.5))
});
var LikesStyles = breakpoints({
  base: css(templateObject_25 || (templateObject_25 = __makeTemplateObject(["\n    display: flex;\n    align-items: center;\n    gap: ", ";\n  "], ["\n    display: flex;\n    align-items: center;\n    gap: ", ";\n  "])), theme.UNIT(2))
});
var LikeButtonStyles = breakpoints({
  base: css(templateObject_28 || (templateObject_28 = __makeTemplateObject(["\n    text-transform: uppercase;\n    color: ", ";\n    ", "\n\n    ", "\n  "], ["\n    text-transform: uppercase;\n    color: ", ";\n    ", "\n\n    ", "\n  "])), theme.COLOR('mid'), function (_a) {
    var hasLikes = _a.hasLikes;
    return !hasLikes && css(templateObject_26 || (templateObject_26 = __makeTemplateObject(["\n      margin-right: ", ";\n    "], ["\n      margin-right: ", ";\n    "])), theme.UNIT(2));
  }, function (_a) {
    var _isReply = _a._isReply;
    return !_isReply && css(templateObject_27 || (templateObject_27 = __makeTemplateObject(["\n      &:before {\n        content: '\u2022';\n        color: ", ";\n        margin-right: ", ";\n      }\n    "], ["\n      &:before {\n        content: '\u2022';\n        color: ", ";\n        margin-right: ", ";\n      }\n    "])), theme.COLOR('text-subtle'), theme.UNIT(1));
  })
});
var LikedPeopleStyles = breakpoints({
  base: css(templateObject_29 || (templateObject_29 = __makeTemplateObject(["\n    text-transform: none;\n    font-size: 1em;\n  "], ["\n    text-transform: none;\n    font-size: 1em;\n  "])))
});
var ReplyButtonStyles = breakpoints({
  base: css(templateObject_30 || (templateObject_30 = __makeTemplateObject(["\n    margin-right: ", ";\n    text-transform: uppercase;\n    color: ", ";\n  "], ["\n    margin-right: ", ";\n    text-transform: uppercase;\n    color: ", ";\n  "])), theme.UNIT(2), theme.COLOR('mid'))
});
var EllipsisStyles = breakpoints({
  base: css(templateObject_31 || (templateObject_31 = __makeTemplateObject(["\n    flex-shrink: 0;\n  "], ["\n    flex-shrink: 0;\n  "])))
});
var LikedUsersTooltipStyles = breakpoints({
  base: css(templateObject_32 || (templateObject_32 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var TooltipModalStyles = breakpoints({
  base: css(templateObject_33 || (templateObject_33 = __makeTemplateObject(["\n    display: flex;\n    flex-direction: column;\n  "], ["\n    display: flex;\n    flex-direction: column;\n  "])))
});
// -------- Components -------->
var My = {
  Container: styled.div(templateObject_34 || (templateObject_34 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Avatar: styled(EntityBubbleImage)(templateObject_35 || (templateObject_35 = __makeTemplateObject(["", ""], ["", ""])), AvatarStyles),
  Body: styled.article(templateObject_36 || (templateObject_36 = __makeTemplateObject(["", ""], ["", ""])), BodyStyles),
  HeaderSources: styled.div(templateObject_37 || (templateObject_37 = __makeTemplateObject(["", ""], ["", ""])), HeaderSourcesStyles),
  UserControls: styled.div(templateObject_38 || (templateObject_38 = __makeTemplateObject(["", ""], ["", ""])), UserControlsStyles),
  Organisation: styled(EntityLink)(templateObject_39 || (templateObject_39 = __makeTemplateObject(["", ""], ["", ""])), OrganisationStyles),
  Creator: styled(EntityLink)(templateObject_40 || (templateObject_40 = __makeTemplateObject(["", ""], ["", ""])), CreatorStyles),
  EditButton: styled(IconButton)(templateObject_41 || (templateObject_41 = __makeTemplateObject(["", ""], ["", ""])), EditButtonStyles),
  DeleteButton: styled(IconButton)(templateObject_42 || (templateObject_42 = __makeTemplateObject(["", ""], ["", ""])), DeleteButtonStyles),
  Likes: styled.div(templateObject_43 || (templateObject_43 = __makeTemplateObject(["", ""], ["", ""])), LikesStyles),
  LikeButton: styled(IconButton)(templateObject_44 || (templateObject_44 = __makeTemplateObject(["", ""], ["", ""])), LikeButtonStyles),
  LikedPeople: styled(EntityStack)(templateObject_45 || (templateObject_45 = __makeTemplateObject(["", ""], ["", ""])), LikedPeopleStyles),
  ReplyButton: styled(IconButton)(templateObject_46 || (templateObject_46 = __makeTemplateObject(["", ""], ["", ""])), ReplyButtonStyles),
  TimeDates: styled.div(templateObject_47 || (templateObject_47 = __makeTemplateObject(["", ""], ["", ""])), TimeDatesStyles),
  When: styled.time(templateObject_48 || (templateObject_48 = __makeTemplateObject(["", ""], ["", ""])), WhenStyles),
  Ellipsis: styled(EllipsisButton)(templateObject_49 || (templateObject_49 = __makeTemplateObject(["", ""], ["", ""])), EllipsisStyles),
  LikedUsersTooltip: styled(InfoTooltip)(templateObject_50 || (templateObject_50 = __makeTemplateObject(["", ""], ["", ""])), LikedUsersTooltipStyles),
  TooltipModal: styled.div(templateObject_51 || (templateObject_51 = __makeTemplateObject(["", ""], ["", ""])), TooltipModalStyles),
  FooterSources: styled.div(templateObject_52 || (templateObject_52 = __makeTemplateObject(["", ""], ["", ""])), FooterSourcesStyles),
  Comment: styled(ContentNode)(templateObject_53 || (templateObject_53 = __makeTemplateObject(["", ""], ["", ""])), CommentStyles)
};
export var Comment = function (props) {
  var className = props.className,
    entity = props.entity,
    isReply = props.isReply,
    onEdit = props.onEdit,
    onDelete = props.onDelete,
    onCurrentCommentClick = props.onCurrentCommentClick,
    canDelete = props.canDelete,
    canEdit = props.canEdit,
    showEditControls = props.showEditControls,
    isTopLevelComment = props.isTopLevelComment;
  var avatarSize = isReply ? 36 : 48;
  var activePerson = useActivePerson();
  var t = useLang();
  var _a = useCommentMutations(),
    likeComment = _a.likeComment,
    unlikeComment = _a.unlikeComment;
  var createdBy = entity.createdBy,
    created = entity.created,
    description = entity.description,
    isWriteable = entity.isWriteable,
    _b = entity.likedBy,
    likedBy = _b === void 0 ? [] : _b;
  var organisation = (createdBy || {}).organisation;
  var hasLikes = !!likedBy.length;
  var likesLabel = likedBy.length === 1 ? t('Like') : t('Likes');
  var activeUserHasLiked = entity.likedBy.some(function (user) {
    var _a;
    return user.id === ((_a = activePerson === null || activePerson === void 0 ? void 0 : activePerson.person) === null || _a === void 0 ? void 0 : _a.id);
  });
  var onCommentLike = function (id) {
    return __awaiter(void 0, void 0, void 0, function () {
      var error_1, error_2;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            if (!activeUserHasLiked) return [3 /*break*/, 5];
            _a.label = 1;
          case 1:
            _a.trys.push([1, 3,, 4]);
            return [4 /*yield*/, unlikeComment({
              variables: {
                id: id
              }
            })];
          case 2:
            _a.sent();
            return [3 /*break*/, 4];
          case 3:
            error_1 = _a.sent();
            console.error("Error unliking comment:", error_1);
            return [3 /*break*/, 4];
          case 4:
            return [3 /*break*/, 8];
          case 5:
            _a.trys.push([5, 7,, 8]);
            return [4 /*yield*/, likeComment({
              variables: {
                id: id
              }
            })];
          case 6:
            _a.sent();
            return [3 /*break*/, 8];
          case 7:
            error_2 = _a.sent();
            console.error("Error liking comment:", error_2);
            return [3 /*break*/, 8];
          case 8:
            return [2 /*return*/];
        }
      });
    });
  };
  // TO-DO - Add isWriteable to the list of conditions to display editButton and DeleteButton
  return React.createElement(EntityProvider, {
    value: entity
  }, React.createElement(My.Container, {
    className: className,
    _isReply: isReply
  }, React.createElement(My.Avatar, {
    size: avatarSize,
    entity: createdBy,
    showBorder: true
  }), React.createElement(My.Body, null, React.createElement(My.HeaderSources, null, React.createElement(My.UserControls, null, React.createElement(My.Creator, {
    entity: createdBy
  }), organisation && React.createElement(My.Organisation, {
    entity: organisation
  }), showEditControls && isWriteable && canEdit && React.createElement(My.EditButton, {
    iconColor: 'mid',
    hoverState: 'animate',
    onClick: onEdit,
    iconSize: 16,
    icon: React.createElement(PencilUnderlineIconGlyph, null)
  }), showEditControls && isWriteable && canDelete && React.createElement(My.DeleteButton, {
    iconColor: 'mid',
    hoverState: 'animate',
    onClick: onDelete,
    iconSize: 16,
    icon: React.createElement(BinIconGlyph, null)
  })), React.createElement(My.TimeDates, null, React.createElement(My.When, null, formatDateTimeString(created, "h:mm A - MMM DD", 'YYYY-MM-DDTHH:mm:ss.SS')))), React.createElement(My.Comment
  // showEmbeds 
  // entityTypeNameEmbedExclusions={["Person", "Team"]} 
  , {
    // showEmbeds 
    // entityTypeNameEmbedExclusions={["Person", "Team"]} 
    entity: description
  }), React.createElement(My.FooterSources, null, isTopLevelComment && React.createElement(My.ReplyButton, {
    iconSize: 19,
    hoverState: 'animate',
    iconColor: 'mid',
    icon: React.createElement(ReplyIconGlyph, null),
    onClick: onCurrentCommentClick
  }, t('Reply')), React.createElement(My.Likes, null, React.createElement(My.LikeButton, {
    hasLikes: hasLikes,
    _isReply: isReply,
    hoverState: 'animate',
    iconColor: activeUserHasLiked ? 'primary' : 'mid',
    iconSize: 17,
    onClick: function () {
      return onCommentLike(entity.id);
    },
    icon: activeUserHasLiked ? React.createElement(ThumbsUpFilledIconGlyph, null) : React.createElement(ThumbsUpIconGlyph, null)
  }, t(!activeUserHasLiked && 'Like')), !!likedBy.length && React.createElement(My.LikedUsersTooltip, {
    id: entity.id,
    showIcon: false,
    tooltip: React.createElement(My.TooltipModal, null, likedBy.map(function (user) {
      return React.createElement("span", {
        key: user.id
      }, user.name);
    }))
  }, React.createElement(My.LikedPeople, {
    variant: 'small',
    gap: -6,
    items: likedBy
  }, t(likesLabel))))))));
};
Comment.defaultProps = CommentDefaultProps;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15, templateObject_16, templateObject_17, templateObject_18, templateObject_19, templateObject_20, templateObject_21, templateObject_22, templateObject_23, templateObject_24, templateObject_25, templateObject_26, templateObject_27, templateObject_28, templateObject_29, templateObject_30, templateObject_31, templateObject_32, templateObject_33, templateObject_34, templateObject_35, templateObject_36, templateObject_37, templateObject_38, templateObject_39, templateObject_40, templateObject_41, templateObject_42, templateObject_43, templateObject_44, templateObject_45, templateObject_46, templateObject_47, templateObject_48, templateObject_49, templateObject_50, templateObject_51, templateObject_52, templateObject_53;